import classNames from 'classnames';
import ArrowRightPink from '../../assets/images/arrow-right-pink.svg';
import ArrowRightWhite from '../../assets/images/arrow-right-white.svg';

type ButtonType = 'solid' | 'outline';

const BUTTON_CLASSES = "button-animate group min-w-36 px-6 tracking-[3px] [&>img]:hidden cursor-pointer rounded-full text-lg h-12 w-auto font-bold flex justify-center items-center gap-2 disabled:cursor-not-allowed";
const SOLID_CLASSES = "bg-crayola-pink text-white [@media(hover){&:hover}]:bg-crayola-dark-pink disabled:bg-crayola-dark-gray";
const OUTLINE_CLASSES = "border-2 text-crayola-dark-pink border-crayola-pink bg-white [@media(hover){&:hover}]:bg-crayola-pale-pink disabled:border-crayola-dark-gray disabled:text-crayola-dark-gray disabled:hover:bg-white";

export function Button({ 
  type,
  text,
  onClick,
  disabled = false,
  rightArrow = false,
  leftArrow = false,
  role = "button",
  fullWidth = false
}: { 
  type: ButtonType;
  text: string;
  onClick: () => void;
  disabled?: boolean;
  rightArrow?: boolean;
  leftArrow?: boolean;
  role?: string;
  fullWidth?: boolean;
}) {
  return (
    <button
      role={role}
      disabled={disabled}
      onClick={onClick}
      className={classNames(
        BUTTON_CLASSES,
        type === 'solid' ? SOLID_CLASSES : OUTLINE_CLASSES,
        fullWidth && 'w-full'
      )}
    >
      {
        leftArrow && !disabled && <div className="hidden group-hover:flex group-hover:rotate-180">
          {type === 'outline' && <img alt="" src={ArrowRightPink} />}
          {type === 'solid' && <img alt="" src={ArrowRightWhite} />}
        </div>
      }
      <span>{text}</span>
      {
        rightArrow && !disabled && <div className="right-arrow">
          {type === 'outline' && <img alt="" src={ArrowRightPink} />}
          {type === 'solid' && <img alt="" src={ArrowRightWhite} />}
        </div>
      }
    </button>
  )
}